export default __webpack_public_path__ + "media/images/mailer/icon_email.png";